// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"8d01e973","239":"6026047b","389":"5ea6c107","395":"80b9d515","453":"93cd86e9","455":"3329e841","547":"bd1fa963","857":"56c58cb1","946":"b4fd0798"}[chunkId] + ".chunk.js";
};